<template>
  <div class="HomePageDashboardMobileFilterDialog">
    <div>
      <el-dialog :visible.sync="filter_dialog_visible" :before-close="handleClose">
        <div class="filter-header">
          <div>
            {{
              active_sub_menu
              ? active_sub_menu.split("_").join(" ")
              : active_sub_menu
            }}
          </div>
        </div>

        <div class="filter-section-title">
          <div>
            <span class="border-bottom relative">Filters</span>
          </div>
          <span class="input-label-gray cursor-pointer" @click="resetFilter()">reset all</span>
        </div>

        <div class="filter-section bottom-margin-15">
          <!-- filters for filter tab 1 -->
          <div class="filter-option" style="padding-bottom: 50px;">
            <div>
              <div v-for="(filter, index) in filter_list" :key="index">
                <div class="filter-toggle-content" :class="{
                  'active-menu-bgColor': active_index_title == filter.title,
                }">
                  <div class="filter-title" @click="showFiltersSubMenues(filter.title, filter)">
                    {{ filter.title }}
                    <i v-if="active_index_title == filter.title" class="el-icon-minus"></i>
                    <i v-else class="el-icon-plus"></i>
                  </div>

                  <div v-if="active_index_title == filter.title">
                    <div v-if="filter.title == 'Market cap' ||
                      filter.title == 'Reco type'
                      ">
                      <div v-for="(filter, index1) in filter.filter" :key="index1">
                        <el-checkbox-group v-model="checked_filters" @change="applyFilter()">
                          <el-checkbox class="filter-tab" :label="filter"></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>

                    <!-- search stock section -->
                    <div v-if="filter.title == 'Search stock'">
                      <div class="flex top-margin-10" style="width: 100%;">
                        <el-select v-model="search_stock" filterable remote reserve-keyword
                          placeholder="Search Company E.g. Infosys" class="seach-input" size="small" clearable
                          :loading="is_search_stock_loading" :remote-method="searchStockList"
                          @change="handleStock(search_stock)">
                          <el-option v-for="stock in stock_list" :key="stock.id" :label="stock.name" :value="stock.id">
                            <span class="searched-stock-title">{{
                              stock.name
                            }}</span>
                            &nbsp;
                            <span class="input-label-gray" v-if="stock.symbol">({{ stock.symbol }})</span>
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <!-- market expert dropdown section -->
                    <div v-if="filter.title == 'Market Participants'">
                      <div class="flex top-margin-10" style="width: 100%;">
                        <el-select v-model="search_expert" filterable remote reserve-keyword
                          placeholder="Search Expert E.g. Motilal Os" class="seach-input" size="small" clearable
                          :loading="is_search_expert_loading" :remote-method="searchExpertList"
                          @change="handleExpert(search_expert)">
                          <el-option v-for="expert in searched_expert_list" :key="expert.id" :label="expert.name"
                            :value="expert.id">
                          </el-option>
                        </el-select>
                      </div>

                      <div v-if="filter.experts">
                        <div v-for="(expert, index1) in filter.experts" :key="index1">
                          <div>
                            <div class="top-margin-10 label-xss-black font-weight-600 cursor-pointer flex-space-between"
                              @click="
                                showSubMarketExperts(expert, index, index1)
                                ">
                              {{ expert.profession }}
                              <i v-if="expert.toggled" class="el-icon-minus label-xss-black"></i>
                              <i v-else class="el-icon-plus label-xss-black"></i>
                            </div>
                            <div v-if="expert.toggled" style="overflow-y: auto; max-height: 150px; overflow-x: hidden;"
                              id="scroll1">
                              <div v-for="(item, index2) in expert.data" :key="index2">
                                <el-checkbox-group v-model="checked_expert_filters"
                                  @change="selectExpert(expert, index2)">
                                  <el-checkbox class="filter-tab" :label="item.id" ref="expert_checkbox">{{ item.name
                                  }}</el-checkbox>
                                </el-checkbox-group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="filter.title == 'Market Participants' &&
                        !filter.experts
                        ">
                        <div v-for="(filter, index1) in filter.filter" :key="index1">
                          <el-checkbox-group v-model="checked_experts_profession_filters"
                            @change="applyExpertProfessionFilter()">
                            <el-checkbox class="filter-tab" :label="filter"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </div>

                    <!-- sector dropdown section -->
                    <div v-if="filter.title == 'Sectors'">
                      <el-select class="top-margin-10 width-100" v-model="sector" size="small" collapse-tags clearable
                        @change="selectSector(sector)" placeholder="Select Sector">
                        <el-option v-for="item in sector_list" :key="item.id" :label="item.name"
                          :value="item.name"></el-option>
                      </el-select>
                    </div>

                    <div v-if="filter.title == 'Rating'" class="top-margin-5">
                      <el-rate :allow-half="true" v-model="star_rating" @change="changeRating()"></el-rate>
                    </div>

                    <!-- <div v-if="filter.title == 'Term'">
                      <el-radio-group v-model="term" @change="changeTerm()">
                        <el-radio class="filter-tab" label="Short term">Short term</el-radio>
                        <el-radio class="filter-tab" label="Long term">Long term</el-radio>
                      </el-radio-group>
                    </div> -->

                    <div v-if="filter.title == 'Target period'">
                      <el-select class="top-margin-10 width-100" v-model="target_period_type" size="small" filterable
                        placeholder="Select" @change="selecteTargetPeriod()">
                        <el-option v-for="item in target_period_type_list" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>

                      <div v-if="target_period_type == 'shortTerm'">
                        <div>
                          <el-checkbox class="filter-tab" v-model="week_check" @change="setActivePeriodBtn('Week')">
                            Week
                          </el-checkbox>

                        </div>

                        <div>
                          <el-checkbox class="filter-tab" v-model="month_check"
                            @change="setActivePeriodBtn('Month')">Month</el-checkbox>
                        </div>
                      </div>

                      <div v-if="target_period_type == 'midTerm'">
                        <div>
                          <el-checkbox class="filter-tab" v-model="current_quarter" @change="setTargetPeriod('Quarter')">
                            Quarter
                          </el-checkbox>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

      <div class="mobile-filter-icon-section">
        <img src="../assets/images/company/filter_icon.svg" title="Filter" class="mobile-filter-icon"
          @click="openFilterDialog" />
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import { EventBus } from "../eventBus";
import { HelperNetworkCallBack } from "../mixins/Helper";

export default {
  name: "HomePageDashboardMobileFilterDialog",

  mixins: [HelperNetworkCallBack],

  props: ["active_sub_menu", "filterList", "resetFilters"],

  data() {
    return {
      filter_dialog_visible: false,
      active_index_title: 0,

      filter_obj: {
        filters: [],
        experts: [],
        company_list: [],
        profession: [],
        stocks: [],
        sector: "",
        rating: "",
        target_period: {},
        term: "",
      },

      term: "",

      checked_filters: [],
      checked_expert_filters: [],
      checked_experts_profession_filters: [],

      sector: "",
      sector_list: [],

      // for search expert
      search_expert: "",
      searched_expert_list: [],
      is_search_expert_loading: false,

      //for search stock
      search_stock: "",
      stock_list: [],
      is_search_stock_loading: false,

      target_period_type: "",
      target_period_type_list: [
        {
          label: "Intraday",
          value: "IntraDay",
        },
        {
          label: "Short Term",
          value: "shortTerm",
        },
        {
          label: "Mid Term",
          value: "midTerm",
        },
        {
          label: "Long Term",
          value: "longTerm",
        },
      ],

      week_check: false,
      month_check: false,
      quarter_check: false,
      current_quarter: false,
      next_quarter: false,
      start_week_year: "",
      end_week_year: "",
      start_week: "",
      end_week: "",

      start_month_year: "",
      end_month_year: "",
      start_month: "",
      end_month: "",

      start_quarter_year: "",
      end_quarter_year: "",
      start_quarter: "",
      end_quarter: "",

      star_rating: null,
    };
  },

  watch: {
    resetFilters() {
      this.active_index_title = 0;
      this.checked_filters = [];
      this.checked_expert_filters = [];
      this.checked_experts_profession_filters = [];
      this.star_rating = null;

      this.term = "";

      this.sector = "";

      this.search_expert = "";

      this.search_stock = "";

      this.target_period_type = "";

      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;

      this.start_week_year = "";
      this.end_week_year = "";
      this.start_week = "";
      this.end_week = "";

      this.start_month_year = "";
      this.end_month_year = "";
      this.start_month = "";
      this.end_month = "";

      this.start_quarter_year = "";
      this.end_quarter_year = "";
      this.start_quarter = "";
      this.end_quarter = "";

      this.filter_obj = {
        filters: [],
        experts: [],
        company_list: [],
        profession: [],
        stocks: [],
        sector: "",
        term: "",
        rating: "",
        target_period: {},
      };

      this.getSectorList();

      // if page is top performers then called get called
      if (this.active_sub_menu == "TOP_EXPERTS") {
        this.getCategoryWiseExpertList();
      }
    },
  },

  mounted() {
    this.getSectorList();

    // if page is top performers then called get called
    if (this.active_sub_menu == "TOP_EXPERTS") {
      this.getCategoryWiseExpertList();
    }

    EventBus.$on("clearAllSelectedFilters", (event) => {
      this.resetFilter();
    });
  },

  methods: {
    showFiltersSubMenues(title, filter) {
      // if filter is accessible for non paid users
      if (filter.filter_type != "Free") {
        // checked subscribed plan has access to this filter
        if (
          !Object.keys(this.subscribedPlanDetails).length ||
          this.subscribedPlanDetails.plan == "Lite"
        ) {
          this.$store.commit("commitSubscribPlanDialogVisibility", true);
          return;
        }
      }

      if (this.active_index_title == "") {
        this.active_index_title = title;
      } else if (this.active_index_title == title) {
        this.active_index_title = "";
      } else {
        this.active_index_title = title;
      }
    },

    showSubMarketExperts(expert) {
      if (expert.toggled) {
        expert.toggled = false;
      } else {
        expert.toggled = true;
      }
    },

    selectExpert(expert, index) {
      if (expert.profession != "company") {
        if (this.filter_obj.experts.indexOf(expert.data[index].id) == -1) {
          this.filter_obj.experts.push(expert.data[index].id);
        } else {
          let i = this.filter_obj.experts.indexOf(expert.data[index].id);
          this.filter_obj.experts.splice(i, 1);
        }
      } else if (expert.profession == "company") {
        if (this.filter_obj.company_list.indexOf(expert.data[index].id) == -1) {
          this.filter_obj.company_list.push(expert.data[index].id);
        } else {
          let i = this.filter_obj.company_list.indexOf(expert.data[index].id);
          this.filter_obj.company_list.splice(i, 1);
        }
      }

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
      this.filter_dialog_visible = false;
    },

    //api to get stocks by search stock string
    searchExpertList: _.debounce(function (query) {
      this.searched_expert_list = [];
      this.is_search_expert_loading = true; //enabled loader

      serverAddr
        .post("/stockants_pro/search-expert-dashboard/", {
          search: query,
          // duration: this.filter_obj.target_period.key ? [] : this.filter_obj.term == "Short term" ? ["Week", "Month", "Quarter"] : this.filter_obj.term == "Long term" ? ["Long_term"] : ["Week", "Month", "Quarter", "Long_term"],
          // target_period: this.filter_obj.target_period
        })
        .then((response) => {
          if (response.data.status) {
            this.searched_expert_list = response.data.data;
          } else {
            this.searched_expert_list = [];
          }

          this.is_search_expert_loading = false; //disabled loader
        })
        .catch(function (error) {
          console.log(error);
          this.is_search_expert_loading = false; //disabled loader
        });
    }, 350),

    //api to get stocks by search stock string
    searchStockList: _.debounce(function (query) {
      this.stock_list = [];
      this.is_search_stock_loading = true; //enabled loader

      serverAddr
        .post(`/performers/v1/stock/search_stock/?q=${query}`)
        .then((response) => {
          if (response.data.status) {
            this.stock_list = response.data.data;
          } else {
            this.stock_list = [];
          }

          this.is_search_stock_loading = false; //disabled loader
        })
        .catch(function (error) {
          console.log(error);
          this.is_search_stock_loading = false; //disabled loader
        });
    }, 350),

    //select stock
    handleStock(item) {
      if (item) {
        if (this.filter_obj.stocks.indexOf(item) == -1) {
          this.filter_obj.stocks.push(item); //checked if expert is already pushed
        }
      } else {
        this.filter_obj.stocks = []; //cleared previously selected stocks
      }

      EventBus.$emit("emitSelectedFilters", this.filter_obj); //emitted event after selecting stock
      this.filter_dialog_visible = false;
    },

    //select seached expert
    handleExpert(item) {
      if (item) {
        if (this.checked_expert_filters.indexOf(item) == -1) {
          this.checked_expert_filters.push(item); //checked if expert is already pushed
        }
        this.filter_obj.experts = this.checked_expert_filters;

        EventBus.$emit("emitSelectedFilters", this.filter_obj); //emitted event after selecting seached expert
        this.filter_dialog_visible = false;
      }
    },

    //get market experts list
    getCategoryWiseExpertList() {
      serverAddr
        .get("/stockants_pro/category-wise-expert/")
        .then((response) => {
          if (response.data.status) {
            response.data.data.forEach((element) => {
              this.$set(element, "toggled", false); //created toggled key to toggle expert list
            });
            for (let index = 0; index < response.data.data.length; index++) {
              if (
                response.data.data[index].profession == "Financial Advisor" ||
                response.data.data[index].profession == "Analyst"
              ) {
                this.filterList[0].experts.push(response.data.data[index]);
              }
            }
          } else {
            this.filterList[0].experts = [];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //api to get sector list
    getSectorList() {
      serverAddr
        .post("stockants_pro/search-sector-dashboard/", {
          duration: this.filter_obj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          target_period: this.filter_obj.target_period,
        })
        .then((response) => {
          if (response.data.status) {
            this.sector_list = response.data.data;
          } else {
            this.sector_list = [];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectSector(sector) {
      this.filter_obj.sector = sector;
      EventBus.$emit("emitSelectedFilters", this.filter_obj);
      this.filter_dialog_visible = false;
    },

    applyFilter() {
      this.filter_obj.filters = this.checked_filters;
      EventBus.$emit("emitSelectedFilters", this.filter_obj);
      this.filter_dialog_visible = false;
    },

    applyExpertProfessionFilter() {
      this.filter_obj.profession = this.checked_experts_profession_filters;
      EventBus.$emit("emitSelectedFilters", this.filter_obj);
      this.filter_dialog_visible = false;
    },

    changeTerm() {
      // this.filter_obj.sector = "";
      // this.sector = "";   //cleared sector on term selction because sector gets changed on short term and long term basis
      this.filter_obj.term = this.term;

      // reset previously selected target period filters
      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;

      this.start_week_year = "";
      this.end_week_year = "";
      this.start_week = "";
      this.end_week = "";

      this.start_month_year = "";
      this.end_month_year = "";
      this.start_month = "";
      this.end_month = "";

      this.start_quarter_year = "";
      this.end_quarter_year = "";
      this.start_quarter = "";
      this.end_quarter = "";

      this.filter_obj.target_period = {};

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
      this.filter_dialog_visible = false;
    },

    selecteTargetPeriod() {
      if (
        this.target_period_type == "IntraDay" ||
        this.target_period_type == "longTerm"
      ) {
        this.filter_obj.target_period.key =
          this.target_period_type == "longTerm"
            ? "Long_term"
            : this.target_period_type;
        EventBus.$emit("emitSelectedFilters", this.filter_obj); //to filter data by week, month, quarter only
        this.filter_dialog_visible = false;
      }

      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;
      this.current_quarter = false;
    },

    changeRating() {
      this.filter_obj.rating = this.star_rating;
      EventBus.$emit("emitSelectedFilters", this.filter_obj);
      this.filter_dialog_visible = false;
    },

    resetFilter() {
      // if current route is expert dashboard then checked subscribed plan has access to this filter -- same component is being used on expert dashboard, user dashboard and dashboard (top performers) pages
      if (
        (!Object.keys(this.subscribedPlanDetails).length ||
          this.subscribedPlanDetails.plan == "Lite") &&
        (this.$router.currentRoute.path == "/expert-dashboard" ||
          this.$router.currentRoute.path == "/dashboard")
      ) {
        this.$store.commit("commitSubscribPlanDialogVisibility", true);
        return;
      }

      // clear all applied filters
      this.checked_filters = [];
      this.checked_expert_filters = [];
      this.checked_experts_profession_filters = [];
      this.star_rating = null;

      this.term = "";

      this.sector = "";

      this.search_expert = "";

      this.search_stock = "";

      this.target_period_type = "";

      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;

      this.start_week_year = "";
      this.end_week_year = "";
      this.start_week = "";
      this.end_week = "";

      this.start_month_year = "";
      this.end_month_year = "";
      this.start_month = "";
      this.end_month = "";

      this.start_quarter_year = "";
      this.end_quarter_year = "";
      this.start_quarter = "";
      this.end_quarter = "";

      this.filter_obj = {
        filters: [],
        experts: [],
        company_list: [],
        profession: [],
        stocks: [],
        sector: "",
        term: "",
        rating: "",
        target_period: {},
      };

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
      this.filter_dialog_visible = false;
    },

    clearFields(title) {
      if (title == "Week") {
        this.start_week = "";
        this.end_week = "";
        this.end_week_year = "";
      } else if (title == "Month") {
        this.start_month = "";
        this.end_month = "";
        this.end_month_year = "";
      } else if (title == "Quarter" || title == "Long_term") {
        this.start_quarter = "";
        this.end_quarter = "";
        this.end_quarter_year = "";
      }

      if (this.term == "Short term") {
        this.filter_obj.target_period = {};
        this.filter_obj.target_period.key = title;
      } else if (this.term == "Long term") {
        delete this.filter_obj.target_period.key;
        this.filter_obj.target_period = {};
      } else {
        this.filter_obj.target_period = {};
        this.filter_obj.target_period.key = title;
      }

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    setTargetPeriod(title) {
      if (title == "Week") {
        if (
          this.start_week_year != "" &&
          this.end_week_year != "" &&
          this.start_week != "" &&
          this.end_week != ""
        ) {
          this.filter_obj.target_period.from_year = this.start_week_year;
          this.filter_obj.target_period.to_year = this.end_week_year;
          this.filter_obj.target_period.start_month = this.start_week;
          this.filter_obj.target_period.end_month = this.end_week;

          this.filter_obj.target_period.key = title;

          EventBus.$emit("emitSelectedFilters", this.filter_obj);
        }
      } else if (title == "Month") {
        if (
          this.start_month_year != "" &&
          this.end_month_year != "" &&
          this.start_month != "" &&
          this.end_month != ""
        ) {
          this.filter_obj.target_period.from_year = this.start_month_year;
          this.filter_obj.target_period.to_year = this.end_month_year;
          this.filter_obj.target_period.start_month = this.start_month;
          this.filter_obj.target_period.end_month = this.end_month;

          this.filter_obj.target_period.key = title;

          EventBus.$emit("emitSelectedFilters", this.filter_obj);
        }

      } else if (title == "Quarter") {
        this.current_quarter = true;
        this.filter_obj.target_period.key = title;

        EventBus.$emit("emitSelectedFilters", this.filter_obj);
      }
      this.filter_dialog_visible = false;
    },

    getCurrentQuarter(title) {
      var duration_title = "";
      if (title == "Current Quarter" || title == "Next Quarter") {
        duration_title = "Quarter";
      }
      this.filter_obj.target_period.key = duration_title;
      var d = new Date();
      // +4  is used for make financial quarter
      var current_quarter = Math.floor(d.getMonth() / 3) + 4;
      current_quarter =
        current_quarter > 4 ? current_quarter - 4 : current_quarter;
      var next_quarter = current_quarter + 1;
      next_quarter = next_quarter > 4 ? next_quarter - 4 : next_quarter;

      var selected_quarter =
        title == "Next Quarter" ? next_quarter : current_quarter;
      // var month = d.getMonth();
      // get year
      let year = d.getFullYear();

      this.start_quarter = selected_quarter;
      this.end_quarter = selected_quarter;

      if (title == "Next Quarter") {
        if (selected_quarter == 4) {
          this.start_quarter_year = year + 1;
          this.end_quarter_year = year + 1;
        } else {
          this.start_quarter_year = year;
          this.end_quarter_year = year;
        }

        this.next_quarter = true;
        this.current_quarter = false;
      } else {
        this.current_quarter = true;
        this.next_quarter = false;

        this.start_quarter_year = year;
        this.end_quarter_year = year;
      }

      this.filter_obj.target_period.from_year = this.start_quarter_year;
      this.filter_obj.target_period.to_year = this.end_quarter_year;
      this.filter_obj.target_period.start_month = this.start_quarter;
      this.filter_obj.target_period.end_month = this.end_quarter;

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    setActivePeriodBtn: function (title) {
      if (title == "Week") {
        this.week_check = true;
        this.month_check = false;
        this.quarter_check = false;
      } else if (title == "Month") {
        this.month_check = true;
        this.week_check = false;
        this.quarter_check = false;
      } else if (title == "Quarter") {
        this.quarter_check = true;
        this.month_check = false;
        this.week_check = false;
      } else {
        this.week_check = false;
        this.month_check = false;
        this.quarter_check = false;
      }

      this.start_week = "";
      this.end_week = "";
      this.start_week_year = "";
      this.end_week_year = "";

      this.start_month = "";
      this.end_month = "";
      this.start_month_year = "";
      this.end_month_year = "";

      this.start_quarter_year = "";
      this.end_quarter_year = "";
      this.start_quarter = "";
      this.end_quarter = "";

      this.filter_obj.target_period = {};

      this.filter_obj.target_period.key = title;

      EventBus.$emit("emitSelectedFilters", this.filter_obj); //to filter data by week, month, quarter only
      // this.filter_dialog_visible = false;
    },

    // open filter dialog
    openFilterDialog() {
      this.filter_dialog_visible = true;
    },

    //close filter dialog
    handleClose(done) {
      this.filter_dialog_visible = false;
    },
  },

  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    // return filter list
    filter_list() {
      return this.filterList;
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.el-dialog__title {
  color: $secondary-theme-color;
  font-size: 1rem;
}

.HomePageDashboardMobileFilterDialog .el-dialog {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 10px 10px 0 0;
  background-color: $filter-section-background-color;
}

.HomePageDashboardMobileFilterDialog .filter-section {
  background-color: #f7f8fc;
}

.HomePageDashboardMobileFilterDialog .filter-section-title {
  display: flex;
  justify-content: space-around;
  font-weight: 500;
  padding: 25px 0;
}

.HomePageDashboardMobileFilterDialog .filter-header {
  padding-top: 20px;

  div {
    text-align: center;
    border-radius: 20px;
    border: 1px solid #000;
    font-size: 0.8rem;
    font-weight: 600;
    color: #000;
    padding: 5px 20px;
    width: fit-content;
    margin: 0 auto;
  }
}

.HomePageDashboardMobileFilterDialog .border-bottom:after {
  position: absolute;
  bottom: -30px;
  left: 13px;
  width: 22px;
  height: 2px;
  margin-bottom: 25px;
  content: "";
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: $primary-theme-color;
}

.filter-toggle-content {
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
}

.HomePageDashboardMobileFilterDialog .filter-title {
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  .el-icon-plus,
  .el-icon-minus {
    font-size: 0.5rem;
    font-weight: 600;
  }
}

.filter-tab {
  display: block;
  margin-top: 10px;
}

.HomePageDashboardMobileFilterDialog .active-menu-bgColor {
  background: $filter-section-background-color;
}

.HomePageDashboardMobileFilterDialog .seach-input {
  width: 100%;
}

// filters input type css start
.HomePageDashboardMobileFilterDialog .el-input--small .el-input__inner {
  border-radius: 25px !important;
  background: transparent !important;
  border-color: #797979 !important;
  color: #797979;
}

.HomePageDashboardMobileFilterDialog .el-radio__label {
  color: black;
  font-size: 0.8rem;
  font-weight: 400;
}

.HomePageDashboardMobileFilterDialog .el-input__inner::placeholder {
  color: #89898a;
}

.HomePageDashboardMobileFilterDialog .el-select .el-input .el-select__caret {
  /* Internet Explorer */
  color: #89898a;
}

.HomePageDashboardMobileFilterDialog .el-checkbox__inner {
  background-color: #dcdfe6;
}

.HomePageDashboardMobileFilterDialog .el-checkbox__label {
  text-transform: capitalize;
  font-size: 13px;
  color: #000;
  font-weight: 400;
}

.HomePageDashboardMobileFilterDialog .range-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.HomePageDashboardMobileFilterDialog .range-dropdown small {
  width: 100px;
  text-align: right;
  margin-right: 10px;
}

.HomePageDashboardMobileFilterDialog .range-dropdown .el-input--mini .el-input__inner {
  border-radius: 5px !important;
  border-color: #797979;
  background: transparent;
}

@media screen and (max-width: 1283px) {
  .HomePageDashboardMobileFilterDialog .el-dialog {
    width: 90%;
  }

  .HomePageDashboardMobileFilterDialog .el-dialog__body {
    padding: 0px 20px 20px 20px;
  }
}
</style>
<style lang="scss">
.HomePageDashboardMobileFilterDialog .el-select--mini {
  width: 100% !important;
  margin: 0 10px;
}
</style>
